export default __webpack_public_path__ + "static/media/drinks.b5ff2a80.jpg";